import {forwardRef} from 'react';
import {twMerge} from '../../../common/twMerge';
import {TextareaV2} from '../../atoms/TextareaV2/TextareaV2';
import {TextareaFieldV2Props} from './TextareaFieldV2Props.interface';

export const TextareaFieldV2 = forwardRef<
  HTMLTextAreaElement,
  TextareaFieldV2Props
>(({status, disabled, ...props}, ref) => {
  return (
    <div
      className={twMerge(
        'flex w-full items-center rounded-8pxr border-1 border-solid border-theme-transparent-30 py-14pxr px-18pxr',
        status === 'error' &&
          'border-static-point-red bg-[rgb(var(--colors-static-point-red)_/_5%)]',
        disabled && 'border-theme-transparent-20 cursor-not-allowed'
      )}
    >
      <TextareaV2 ref={ref} disabled={disabled} {...props} />
    </div>
  );
});

TextareaFieldV2.displayName = 'TextareaFieldV2';
